import { Box } from '@mui/material';
import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType } from '@repo/segment/enums';
import { type AnalyticsType } from '@repo/segment/types';
import type { CtaType } from '@repo/supergraph/marketplace/types';
import { ProductLogo } from './ProductLogo';

type Props = {
  source?: string;
  alt?: string;
  overrideCta?: CtaType;
  analyticsPayload: AnalyticsType;
  imageMaxWidth?: string;
  shouldShowCta?: boolean;
};

export const LogoWrapper = ({
  source,
  alt,
  overrideCta,
  analyticsPayload,
  imageMaxWidth,
  shouldShowCta = false,
}: Props) => {
  if (!source) {
    return null;
  }

  const logoElement = (
    <ProductLogo {...(alt && { alt })} source={source} imageMaxWidth={imageMaxWidth} />
  );

  if (!overrideCta || !shouldShowCta) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, textAlign: 'center' }}>
        {logoElement}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, textAlign: 'center' }}>
      <Box data-testid="cta-container">
        <CtaLink
          cta={overrideCta}
          Component={Box}
          analyticsPayload={analyticsPayload}
          linkType={LinkType.PRODUCT_IMAGE}
          monetizable={analyticsPayload.monetizable}
          data-testid="product-logo"
        >
          {logoElement}
        </CtaLink>
      </Box>
    </Box>
  );
};
